<template>
  <div>
    <h2>Mot de passe oublié</h2>
    <p>Entrez votre e-mail pour recevoir un lien de réinitialisation.</p>

    <form @submit.prevent="submit">
        <input type="email" v-model="email" placeholder="Adresse e-mail" required />
        <button type="submit" class="primary-button">Envoyer</button>
    </form>

    <p v-if="successMessage" style="color: green;">{{ successMessage }}</p>
    <p v-if="errorMessage" style="color: red;">{{ errorMessage }}</p>
  </div>
</template>


<script setup>
import {ref, reactive,onMounted,computed, watch,} from 'vue';
import apiClient, { setAuthToken } from '@/api'
import { useUserStore } from '@/stores/userstore'

const email = ref('')
const successMessage = ref('')
const errorMessage = ref('')

const submit = async () => {
    successMessage.value = ''
    errorMessage.value = ''
    const frontendBaseUrl = window.location.origin
    try {
        await apiClient.post('/reset_password/',
            {
                email:email.value,
                frontend_url: frontendBaseUrl
            }
        )
        email.value =''
        successMessage.value = 'Un lien de réinitialisation a été envoyé.'
    }catch (err) {
        errorMessage.value = 'Erreur, adresse email inconnue ou serveur indisponible.'
    }
}
 
</script>
<style scoped lang='scss'>
form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  margin-top: 1rem;
}
.primary-button {
    align-self: flex-end;
}
</style>